import { useState, useEffect } from 'react';

/**
 * Hook para gestionar las capas de tipo "overlay" a través del componente LayerSelector
 * 
 * Encapsula la lógica de inicialización y manipulación de los estados relacionados con capas "overlay" basadas en una configuración proporcionada.
 * Se utiliza para gestionar los estados de forma independiente antes de ser exportados 
 * o utilizados globalmente.
 * 
 * @param {Object} config - Configuración inicial que contiene las definiciones de capas y grupos.
 * @returns {Object} - Estados y funciones para manipular las capas "overlay".
 */

const useOverlayLayers = (config) => {
  const [visibleOverlayLayers, setVisibleOverlayLayers] = useState({});
  const [opacities, setOpacities] = useState({});
  const [isOverlayInitializedWithConfig, setIsOverlayInitializedWithConfig] = useState(false);

  // Inicializa las capas visibles basadas en la configuración en config.json
  useEffect(() => {
    if (!isOverlayInitializedWithConfig && config) {
      const individualLayers = config.LAYERS
        .filter((layer) => layer.visible && layer.type === 'overlay')
        .reduce((acc, layer) => {
          acc[layer.name] = { 
            source: layer.source, //source: layer.source,
            url: layer.url        //url: layer.url
          }; 
          return acc;
        }, {});

      const groupLayers = config.GROUPS
        .flatMap((group) => group.layers)
        .filter((layer) => layer.visible && layer.type === 'overlay')
        .reduce((acc, layer) => {
          acc[layer.name] = { 
            source: layer.source, //source: layer.source,
            url: layer.url        //url: layer.url
          }; 
          return acc;
        }, {});

      // Combina los resultados en el estado inicial
      setVisibleOverlayLayers({ ...individualLayers, ...groupLayers });
      setIsOverlayInitializedWithConfig(true);
    }
  }, [config, isOverlayInitializedWithConfig]);

  return {
    visibleOverlayLayers,
    setVisibleOverlayLayers,
    opacities,
    setOpacities,
    isOverlayInitializedWithConfig,
  };
};

export default useOverlayLayers;
